import { Link } from 'react-router-dom';

export default function LocalSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/2929a579eae4ce623d4082a6cde6d752.jpg"
          alt="Lubbock Texas community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-charcoal-900/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-10 bg-gold-400" />
          <span className="text-gold-400 text-xs uppercase tracking-[0.3em] font-sans font-semibold">Proudly Local</span>
          <div className="h-px w-10 bg-gold-400" />
        </div>

        <h2 className="font-serif text-4xl md:text-6xl text-white leading-tight mb-6">
          Sweet Treats Made for<br />
          <em className="italic text-blush-300">Lubbock Celebrations</em>
        </h2>

        <p className="text-cream-200 text-base md:text-xl font-sans font-light leading-relaxed mb-10 max-w-2xl mx-auto">
          We&apos;re proud to serve our Lubbock community with custom desserts for birthdays, weddings, parties, holidays, graduations, and every special moment in between. Locally made, locally loved.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
          {['Birthdays', 'Weddings', 'Baby Showers', 'Holidays', 'Graduations', 'Special Events'].map((ev) => (
            <span
              key={ev}
              className="px-4 py-2 border border-white/40 text-white/90 rounded-full text-sm font-sans backdrop-blur-sm"
            >
              {ev}
            </span>
          ))}
        </div>

        <Link
          to="/custom-orders"
          className="inline-flex items-center gap-2 bg-cream-100 hover:bg-white text-charcoal-800 px-8 py-4 rounded-full font-sans font-semibold text-sm tracking-wide whitespace-nowrap transition-all duration-200 hover:scale-105 cursor-pointer"
        >
          Order for Your Event
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}
